import React from 'react';
import CSSModules from 'react-css-modules';
import style from './navigation.scss';
import { Link } from 'react-router';
import { Container, Row, Col } from './';
import Translate from './translate';



const Navigation = ({ children }) => (
  <div styleName={`root ${process.muhimma.indexOf(process.target[0]) !== -1 ? 'muhimma' : ''}`}>
    <Container>
      <Row>
        <Col md="3/5">
          <ul styleName="nav-bar">
            <li><Link to="/">{Translate.get('home')}</Link></li>
            <li><Link to="/gallery">{Translate.get('gallery')}</Link></li>
          </ul>
        </Col>
        <Col md="2/5">
          <Translate all="true"/>
        </Col>
      </Row>
    </Container>
  </div>
);

export default CSSModules(Navigation, style, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/navigation.js